// src/services/conversaciones.ts
/**
 * Service para operaciones de Conversaciones y Mensajes.
 */
import { api } from './api';
import type {
  Conversacion,
  ConversacionCreate,
  ConversacionUpdate,
  ConversacionFiltros,
  ConversacionAsignar,
  ConversacionPausar,
  Mensaje,
  MensajeCreate,
} from '@/types';

export const conversacionesService = {
  // Listar conversaciones con filtros
  list: (params?: ConversacionFiltros) => {
    const searchParams = new URLSearchParams();
    if (params?.estado) searchParams.set('estado', params.estado);
    if (params?.cliente_id) searchParams.set('cliente_id', params.cliente_id);
    if (params?.asignado_a_id) searchParams.set('asignado_a_id', params.asignado_a_id);
    if (params?.search) searchParams.set('search', params.search);

    const query = searchParams.toString();
    return api.get<Conversacion[]>(`/conversaciones${query ? `?${query}` : ''}`);
  },

  // Obtener conversacion por ID
  get: (id: string) => api.get<Conversacion>(`/conversaciones/${id}`),

  // Crear conversacion
  create: (data: ConversacionCreate) => api.post<Conversacion>('/conversaciones', data),

  // Actualizar conversacion
  update: (id: string, data: ConversacionUpdate) =>
    api.put<Conversacion>(`/conversaciones/${id}`, data),

  // Asignar a usuario
  asignar: (id: string, data: ConversacionAsignar) =>
    api.post<Conversacion>(`/conversaciones/${id}/asignar`, data),

  // Pausar conversacion
  pausar: (id: string, data: ConversacionPausar) =>
    api.post<Conversacion>(`/conversaciones/${id}/pausar`, data),

  // Reanudar conversacion
  reanudar: (id: string) => api.post<Conversacion>(`/conversaciones/${id}/reanudar`),

  // Cerrar conversacion
  cerrar: (id: string) => api.post<Conversacion>(`/conversaciones/${id}/cerrar`),

  // Mensajes
  listarMensajes: (conversacionId: string) =>
    api.get<Mensaje[]>(`/conversaciones/${conversacionId}/mensajes`),

  enviarMensaje: (conversacionId: string, data: MensajeCreate) =>
    api.post<Mensaje>(`/conversaciones/${conversacionId}/mensajes`, data),

  marcarLeidos: (conversacionId: string) =>
    api.post<void>(`/conversaciones/${conversacionId}/leer`),
};
